import { CloseIcon } from "@hightouch/htui";
import {
  ChatSupportIcon,
  ChatSupportUnreadIcon,
} from "src/components/layout/nav/icons/chat-support";
import { NavItem } from "src/components/layout/nav/nav-item";
import { navIcon } from "src/components/layout/nav/nav-icon";
import { useUser } from "src/contexts/user-context";
import * as analytics from "src/lib/analytics";
import {
  closeChat,
  openChat,
  usePylonChatOpen,
  usePylonUnreadCount,
} from "src/lib/pylon";

const CloseChatIcon = navIcon(CloseIcon);

export const ChatSupport = () => {
  const { workspace } = useUser();
  const isOpen = usePylonChatOpen();
  const unreadCount = usePylonUnreadCount();

  const label = isOpen ? "Close chat" : "Chat support";
  const hasUnread = unreadCount > 0 && !isOpen;
  const handleClick = () => {
    if (isOpen) {
      closeChat();
      return;
    }

    analytics.track("Contact support clicked", {
      workspace_id: workspace?.id,
    });
    openChat();
  };

  return (
    <NavItem
      isActive={isOpen}
      icon={
        isOpen
          ? CloseChatIcon
          : hasUnread
            ? ChatSupportUnreadIcon
            : ChatSupportIcon
      }
      label={label}
      ariaLabel={
        hasUnread
          ? `${label}, ${unreadCount} unread message${unreadCount === 1 ? "" : "s"}`
          : undefined
      }
      onClick={handleClick}
    />
  );
};
